<template>
<div class="dash-page">

  <!-- STAT CARDS -->
  <div class="dash-stats">
    <div class="stat-card">
      <div class="stat-value">{{ $helper.parabirimi(posts.Satış,'TL') }}</div>
      <div class="stat-label">Toplam Ciro</div>
    </div>

    <div class="stat-card">
      <div class="stat-value">{{ $helper.parabirimi(posts.Tahsilat,'TL') }}</div>
      <div class="stat-label">Toplam Tahsilat</div>
    </div>

    <div class="stat-card">
      <div class="stat-value">{{ $helper.parabirimi(posts.İade,'TL') }}</div>
      <div class="stat-label">Toplam İade</div>
    </div>

    <div class="stat-card">
      <div class="stat-value">{{ $helper.parabirimi($store.aktifCari.bakiye,'') + 'TL' }}</div>
      <div class="stat-label">Genel Bakiye</div>
    </div>
  </div>

  <!-- CHARTS -->
  <div class="dash-charts">

    <div class="panel" v-if="bitti">
      <div class="panel-head">
        <div class="panel-title">Satış İstatistikleri</div>
        <div class="panel-sub">(adet)</div>
      </div>

      <div class="panel-body panel-body--chart">
        <apexchart
          type="pie"
          width="100%"
          height="100%"
          :options="chartOptionsp"
          :series="series2"
        />
      </div>
    </div>

    <div class="panel" v-if="bitti">
      <div class="panel-head">
        <div class="panel-title">Genel İstatistik</div>
      </div>

      <div class="panel-body panel-body--chart">
        <apexchart
          type="bar"
          height="430"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>

  </div>

</div>

</template>

<script>


export default {

  data() {
    return {
      bitti:false,
      series: [],
      series2: [],
      chartOptions: {
      colors: [
          "rgba(254, 94, 58, 0.5)",
          "rgba(64, 66, 87, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(8, 221, 193, 0.5)",
          "rgba(38, 159, 64, 0.5)",
          "rgba(254, 94, 58, 0.8)",
          "rgba(254, 147, 38, 0.5)",
          "rgba(0, 133, 78, 0.5)",
          "rgba(38, 38, 255, 0.5)",
          "rgba(128, 128, 128, 0.5)",
          "rgba(255, 92, 38, 0.5)",
          "rgba(255, 64, 0, 0.8)",
        ],
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            },
            yaxis: {
              title: {
                text: 'TL (Toplam)'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " TL"
                }
              }
            }
      },
      chartOptionsp: {
      colors: [
          "rgba(254, 94, 58, 0.5)",
          "rgba(64, 66, 87, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(8, 221, 193, 0.5)",
          "rgba(38, 159, 64, 0.5)",
          "rgba(254, 94, 58, 0.8)",
                    "rgba(254, 147, 38, 0.5)",
          "rgba(0, 133, 78, 0.5)",
          "rgba(38, 38, 255, 0.5)",
          "rgba(128, 128, 128, 0.5)",
          "rgba(255, 92, 38, 0.5)",
          "rgba(255, 64, 0, 0.8)",
        ],
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
      },
       obje : { 
        pkod: this.$request.ayar().entegrekodu, // personel mi müşterimi hesaplama için
        ckod: this.$store.aktifCari.kod, 
        t1: this.$helper.setFiltre().yillik.t1,
        t2: this.$helper.setFiltre().yillik.t2,
        // t1: '2022.01.01',
        //t2: '2022.01.30',
        durum : 2,
        sayfa:'anasayfa'
      },
      posts : {
      "Satış": {},
      "Tahsilat": {},
      "İade": {},
    },
      //cariKod : this.$helper.kodlama.decode(this.$route.params.kod)
      source: this.$store.aktifCari,
      // alan: this.$store.getters.getModul[this.$route.name.split("-")[0]][
      //   this.$route.name.split("-")[1]
      // ].alias,
      unvan: this.$helper
        .ilkharfBuyuk(this.$store.aktifCari.unvan)
        .substring(0, 50),
        //source: this.$store.getters.getCari.aktif,
        hesap : this.$request.ayar(),
    };
  },
  created() {
    this.getir()
    //this.hesap.pb = 'TL'
  },
  methods: {
    getir() {
      this.posts = [];
      this.series = [];
      //this.series2 = []


      this.$store.setLoading([true,'Bekleyiniz'])
      this.$request.post(this.hesap.program+"/dashboard", this.obje,this.hesap)
        .then((res) => {
          if (res.status != 300) {
          //this.series2.push(res.Satış.toplam)
          //this.series2.push(res.Tahsilat.toplam+res.İade.toplam)
          //this.series2.push(res.İade.toplam)
          this.posts.Satış = res.Satış.toplam;
          this.posts.Tahsilat = res.Tahsilat.toplam;
          this.posts.İade = res.İade.toplam;

          this.series2.push(res.Satış.Ocak.adet,res.Satış.Şubat.adet,res.Satış.Mart.adet,res.Satış.Nisan.adet,res.Satış.Mayıs.adet,res.Satış.Haziran.adet,res.Satış.Temmuz.adet,res.Satış.Ağustos.adet,res.Satış.Eylül.adet,res.Satış.Ekim.adet,res.Satış.Kasım.adet,res.Satış.Aralık.adet)
          this.series.push({
            name: 'Satış',
            data: [res.Satış.Ocak.bakiye,res.Satış.Şubat.bakiye,res.Satış.Mart.bakiye,res.Satış.Nisan.bakiye,res.Satış.Mayıs.bakiye,res.Satış.Haziran.bakiye,res.Satış.Temmuz.bakiye,res.Satış.Ağustos.bakiye,res.Satış.Eylül.bakiye,res.Satış.Ekim.bakiye,res.Satış.Kasım.bakiye,res.Satış.Aralık.bakiye]
          })
          this.series.push({
            name: 'Tahsilat',
            data: [res.Tahsilat.Ocak.bakiye,res.Tahsilat.Şubat.bakiye,res.Tahsilat.Mart.bakiye,res.Tahsilat.Nisan.bakiye,res.Tahsilat.Mayıs.bakiye,res.Tahsilat.Haziran.bakiye,res.Tahsilat.Temmuz.bakiye,res.Tahsilat.Ağustos.bakiye,res.Tahsilat.Eylül.bakiye,res.Tahsilat.Ekim.bakiye,res.Tahsilat.Kasım.bakiye,res.Tahsilat.Aralık.bakiye]
          })
          this.series.push({
            name: 'İade',
            data: [res.İade.Ocak.bakiye,res.İade.Şubat.bakiye,res.İade.Mart.bakiye,res.İade.Nisan.bakiye,res.İade.Mayıs.bakiye,res.İade.Haziran.bakiye,res.İade.Temmuz.bakiye,res.İade.Ağustos.bakiye,res.İade.Eylül.bakiye,res.İade.Ekim.bakiye,res.İade.Kasım.bakiye,res.İade.Aralık.bakiye]
          })
          // this.series.push({
          //   name: 'İade',
          //   data: [res.İade.Ocak.bakiye,res.İade.Şubat.bakiye,res.İade.Mart.bakiye,res.İade.Nisan.bakiye,res.İade.Mayıs.bakiye,res.İade.Haziran.bakiye,res.İade.Temmuz.bakiye,res.İade.Ağustos.bakiye,res.İade.Eylül.bakiye,res.İade.Ekim.bakiye,res.İade.Kasım.bakiye,res.İade.Aralık.bakiye]
          // })
          this.$store.setLoading([false,''])
          this.bitti = true             
          }
          else {
          this.$store.setLoading([false,''])
            this.$router.push("/oturum")
          }

        }).catch(err=>{
          this.$router.push("/oturum")

        })
    },
  },
};
</script>
<style scoped>
.dash-page{
  background:#f6f7fb;
  min-height:100%;
  padding: 14px;
  max-width:100%;
  margin: 0 auto;
}

/* Stat cards */
.dash-stats{
  display:grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 6px;
  margin-bottom: 12px;
}

.stat-card{
  background:#fff;
  border:1px solid #e9ecf3;
  border-radius: 14px;
  box-shadow: 0 10px 22px rgba(17,24,39,0.06);
  padding: 14px 14px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  min-height: 84px;
}

.stat-value{
  font-size: 22px;
  font-weight: 900;
  color:#111827;
  line-height: 1.1;
}

.stat-label{
  margin-top: 6px;
  font-size: 12px;
  color:#6b7280;
  font-weight: 700;
}

/* Charts grid */
.dash-charts{
  display:grid;
  grid-template-columns: 380px 1fr;
  gap: 12px;
  align-items:start;
}

/* Panel */
.panel{
  background:#fff;
  border:1px solid #e9ecf3;
  border-radius: 14px;
  box-shadow: 0 10px 22px rgba(17,24,39,0.06);
  overflow:hidden;
}

.panel-head{
  padding: 12px 14px;
  border-bottom:1px solid #eef1f6;
  background:#fbfbfd;
  display:flex;
  align-items:baseline;
  gap: 8px;
}

.panel-title{
  font-size: 14px;
  font-weight: 900;
  color:#111827;
}

.panel-sub{
  font-size: 12px;
  color:#6b7280;
  font-weight: 700;
}

.panel-body{
  padding: 12px 14px;
}

.panel-body--chart{
  height: 450px; /* pie için */
}

/* Responsive */
@media (max-width: 1100px){
  .dash-charts{
    grid-template-columns: 1fr;
  }
  .panel-body--chart{
    height: 420px;
  }
}

@media (max-width: 900px){
  .dash-stats{
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 520px){
  .dash-page{
    padding: 10px;
  }
  .stat-value{
    font-size: 18px;
  }
  .panel-body--chart{
    height: 360px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/cari/dashboard.vue